export const en = {
    country: 'Country',
    disclaimer: 'Warning'
};
